import type { ReactNode } from 'react';

import { DEFAULT_SUPER_ADMIN_TOOLS_PANEL_STYLES, SuperAdminToolsPanelStyles } from './superAdminToolsPanelStyles';

export type SuperAdminToolsRow = { label: string; value: ReactNode };

/** Label and value rows, as Current Org and Server Health show them. */
export const SuperAdminToolsRows = (
  { rows, styles = DEFAULT_SUPER_ADMIN_TOOLS_PANEL_STYLES }: { rows: SuperAdminToolsRow[]; styles?: SuperAdminToolsPanelStyles },
) => (
  <div>
    {rows.map(({ label, value }) => (
      <div key={label} css={styles.row}>
        <span css={styles.label}>{label}</span>
        <span css={styles.value}>{value}</span>
      </div>
    ))}
  </div>
);
